import { Typography } from "@mui/material";
import React from "react";

export const PageTitle = ({ pageName }) => {
  return (
    <Typography variant="h4" component="h5" color="textPrimary" align="left">
      {pageName}
    </Typography>
  );
};
